export const countries = [
  {
    id: 1,
    name: "Algeria",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 2,
    name: "Bahrain",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 3,
    name: "Egypt",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 4,
    name: "Iraq",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 5,
    name: "Jordan",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 6,
    name: "Kuwait",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 7,
    name: "Lebanon",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 8,
    name: "Morocco",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 9,
    name: "Oman",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 10,
    name: "Palestine",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 11,
    name: "Qatar",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 12,
    name: "Saudi Arabia",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 13,
    name: "Syria",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 14,
    name: "Tunisia",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 15,
    name: "United Arab Emirates",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 16,
    name: "Yemen",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 17,
    name: "Cyprus",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 18,
    name: "France",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 19,
    name: "Greece",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 20,
    name: "Italy",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 21,
    name: "Portugal",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 22,
    name: "Spain",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
  {
    id: 23,
    name: "Turkey",
    created_at: "2024-03-13T10:37:32.000000Z",
    updated_at: "2024-03-13T10:37:32.000000Z",
  },
];
